"use client"

import { cn } from "@/lib/utils"
import { BlogPost } from "@/types/blog"
import { BlogCard } from "./BlogCard"
import { EmptyState } from "./EmptyState"
import { StaggeredList } from "@/components/index"

interface BlogGridProps {
  posts: BlogPost[]
  className?: string
}

export function BlogGrid({ posts, className }: BlogGridProps) {
  if (posts.length === 0) {
    return <EmptyState />
  }

  return (
    <StaggeredList
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 lg:gap-8",
        className
      )}
      staggerDelay={80}
      duration={500}
    >
      {posts.map((post) => (
        <BlogCard key={post.slug} post={post} />
      ))}
    </StaggeredList>
  )
}
